<template>
  <section>
    <div class="input">
      <label class="input-top-label">{{
        t.getOrKey("Label.RegistrationNumber")
      }}</label>
      <input
        type="text"
        v-model="registration"
        placeholder="abc-123"
        @change="onChange"
        name="registration"
        :class="{ error: !isRegistrationValid }"
      />
    </div>

    <div class="input">
      <label>{{ t.getOrKey("Label.ReserverName") }}</label>
      <input
        type="text"
        v-model="name"
        placeholder="Matti Meikäläinen"
        name="name"
        @change="onChange"
        :class="{ error: !isNameValid }"
      />
    </div>

    <div class="input">
      <label>{{ t.getOrKey("Label.ReserverPhone") }}</label>
      <input
        type="phone"
        v-model="phone"
        :class="{ error: !isPhoneValid }"
        placeholder="040 123 456"
        name="phone"
        @change="onChange"
      />
    </div>

    <div class="input input-email">
      <label>{{ t.getOrKey("Label.Email") }}</label>
      <input
        type="email"
        :class="{ error: !isValidEmail }"
        v-model="email"
        placeholder="matti.meikalainen@example.com"
        @change="onChange"
        @blur="validateEmail"
      />
    </div>

    <div class="input input-textarea">
      <label>{{ t.getOrKey("Label.AdditionalInfo") }}</label>
      <textarea v-model="additionalInfo" @change="onChange" />
    </div>
  </section>
</template>
<script>
import t from "@/services/translation-service";
export default {
  data() {
    return {
      name: "",
      registration: "",
      email: "",
      isValidEmail: true,
      phone: "",
      additionalInfo: "",
      t: t,
      hasRegistrationChanged: false,
      hasNameChanged: false,
      hasPhoneChanged: false,
    };
  },
  computed: {
    isRegistrationValid() {
      return !this.hasRegistrationChanged || this.registration.length > 0;
    },
    isNameValid() {
      return !this.hasNameChanged || this.name.length > 0;
    },
    isPhoneValid() {
      return !this.hasPhoneChanged || this.phone.length > 0;
    },
  },
  methods: {
    validate(data) {
      this.hasRegistrationChanged = true;
      this.hasNameChanged = true;
      this.hasPhoneChanged = true;
      this.validateEmail();
      if (
        !this.isValidEmail ||
        this.registration.length < 1 ||
        this.name.length < 1 ||
        this.phone.length < 1 ||
        this.email.length < 1
      ) {
        data.isValid = false;
        data.scrollTo = "contactPanel";
      }
    },
    onChange(e) {
      if (e.target.name === "registration") {
        this.hasRegistrationChanged = true;
      }
      if (e.target.name === "name") {
        this.hasNameChanged = true;
      }
      if (e.target.name === "phone") {
        this.hasPhoneChanged = true;
      }
      this.$emit("change", {
        name: this.name,
        registration: this.registration,
        email: this.email,
        phone: this.phone,
        additionalInfo: this.additionalInfo,
      });
    },
    validateEmail() {
      if (this.email && this.email.length > 0) {
        const re = new RegExp(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        if (re.test(this.email)) {
          this.isValidEmail = true;
        } else {
          this.isValidEmail = false;
        }
      } else {
        this.isValidEmail = false;
      }
    },
  },
  created() {
    const queryParams = new URLSearchParams(window.location.search);
    const reg = queryParams.get("registration");
    if (reg && reg.length && reg.length > 0) {
      this.registration = reg;
      this.hasRegistrationChanged = true;
    }
  },
};
</script>
<style scoped>
.input label,
.input input {
  display: block;
  width: 100%;
}
section {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.5rem;
}
.input {
  flex: 1 1 50%;
  padding: 0 0.5rem;
}
textarea {
  width: calc(50% - 0.5rem);
  height: 4rem;
}
@media screen and (max-width: 767px) {
  .input.input-email {
    flex: 1 1 100%;
  }
  textarea {
    width: 100%;
  }
}
</style>
